export const API_URL = "https://api.fluid.fo";
export const CLOUDFLARE_TURNSTILE_SITEKEY = "0x4AAAAAAAL9sDhaBoP0ppfJ";
export const CLOUDFLARE_TURNSTILE_CHECKOUT_SITEKEY = "0x4AAAAAAAL9sWPQ3ZGUesFE";
export const TELEGRAM_CHANNEL_URL = "https://t.me/riptide";
export const STORE_NAME = "Fluid";